import React, { useState } from "react";
import { Form, Input, Select, Button, message } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useLanguage } from "../../context/LanguageContext";
import drEasyApi from "../../Api/Customapi";

export function ContactForm() {
  const [form] = Form.useForm();
  const { t } = useLanguage();
  const [loading,setLoading]=useState(false)
  const handleSubmit = async () => {

    try {
      setLoading(true)
      const payload = form.getFieldsValue()

      await drEasyApi.post("/api/Contact/SendSystemContact", payload)
      message.success(t("contact.success"))

    } catch (err) {
      message.error(err?.response?.data?.message || "Message not sent")
      setLoading(false)
    }finally{
      setLoading(false)
    }
  }


  return (
    <div className="w-full">
      <div className="bg-gradient-to-b from-primary to-secondary  p-6 rounded-2xl shadow-md">

        <Form
          onFinish={handleSubmit}

          form={form}
          layout="vertical"
          className="space-y-2 md:space-y-3          // ← was space-y-3 on all sizes
             [&_.ant-form-item]:mb-2          // ← shrink item gap on mobile
             md:[&_.ant-form-item]:mb-4       // ← restore normal gap on md+
             [&_.ant-form-item-label]:pb-0.5  // ← pull label tighter to input
             md:[&_.ant-form-item-label]:pb-1
             [&_.ant-form-item-label_label]:text-white
             [&_.ant-form-item-label_label]:md:text-lg"
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-3">

            <Form.Item
              label={t("contact.fullName")}
              name="name"
              rules={[{ required: true ,message:t("common.required")}]}
              className="[&_.ant-input]:border-primary"
            >
              <Input
                placeholder={t("contact.fullNamePlaceholder")}
                className="rounded-md md:rounded-xl py-2" 
              />
            </Form.Item>

            {/* Phone */}
            <Form.Item
              name="phone"
              rules={[{ required: true ,message:t("common.required")}]}

              label={t("contact.phoneN")}
              className="[&_.ant-input]:border-yellow-500"
            >
              <Input
                placeholder={t("contact.phonePlaceholder")}
                className="rounded-md md:rounded-xl py-2"
              />
            </Form.Item>
          </div>

          <Form.Item
            label={t("contact.emailA")}

              rules={[{ required: true ,message:t("common.required")}]}
            name="email"
            className="[&_.ant-input]:border-primary"
          >
            <Input
              placeholder={t("contact.emailPlaceholder")}
              className="rounded-md md:rounded-xl py-2"
            />
          </Form.Item>

          <Form.Item
            label={t("contact.serviceNeeded")}
            className="rounded- "
                          rules={[{ required: true ,message:t("common.required")}]}

            name="subject"
          >
            <Input
              placeholder={t("contact.serviceNeededPlaceholder")}
              rows={2}
              className="rounded-md md:rounded-xl"
            />
          </Form.Item>

          <Form.Item
            label={t("contact.message")}
                          rules={[{ required: true ,message:t("common.required")}]}

            name="message"
            className="[&_.ant-input]:border-primary"
          >
            <TextArea
              placeholder={t("contact.messagePlaceholder")}
              rows={4}
              className="rounded-md md:rounded-xl"
            />
          </Form.Item>

          <div className="flex justify-center w-full items-center md:justify-end mt-4">
            <Button    htmlType="submit"
 loading={loading} disabled={loading} type="" className="bg-primary mt-4 h-10 text-xl text-white hover:bg-primary_hover rounded-md w-full  ">
              {t("contact.submit")}
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
}
